import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthComponent, NbAuthService } from '@nebular/auth';
import { Location } from '@angular/common';

@Component({
  selector: 'def-auth',
  styleUrls: ['./auth.component.scss'],
  template: `
		<nb-card>
			<nb-card-body>
				<router-outlet></router-outlet>
			</nb-card-body>
		</nb-card>`,
})
export class AuthComponent extends NbAuthComponent {

  constructor(
    private router: Router,
    protected authService: NbAuthService,
    protected location: Location,
  ) {
    super(authService, location);

    const askedEntryRoute = window.localStorage.getItem('askedEntryRoute');

    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        const commands = askedEntryRoute === '404' ? ['slides/home'] : [askedEntryRoute || 'catalog'];
        this.router.navigate(commands);
      }
    });
  }
}
